'use client'

import { useEffect } from 'react'
import { reportWebVitals, checkPerformanceBudget, analyzeResourceTiming } from '@/lib/performance-tracking'

export function WebVitals() {
  useEffect(() => {
    // Track Core Web Vitals
    if (typeof window !== 'undefined' && 'web-vital' in window) {
      // This will be available when Next.js loads the web-vitals library
      const { onCLS, onFID, onFCP, onLCP, onTTFB } = require('web-vitals')
      
      onCLS((metric: any) => {
        reportWebVitals(metric)
        checkPerformanceBudget(metric)
      })
      
      onFID((metric: any) => {
        reportWebVitals(metric)
        checkPerformanceBudget(metric)
      })
      
      onFCP((metric: any) => {
        reportWebVitals(metric)
        checkPerformanceBudget(metric)
      })
      
      onLCP((metric: any) => {
        reportWebVitals(metric)
        checkPerformanceBudget(metric)
      })
      
      onTTFB((metric: any) => {
        reportWebVitals(metric)
        checkPerformanceBudget(metric)
      })
    }
    
    // Analyze resources after page load
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        // Wait a bit for all resources to complete
        setTimeout(() => {
          analyzeResourceTiming()
        }, 2000)
      })
    }
  }, [])
  
  return null
}